import { render, staticRenderFns } from "./educateNormal.vue?vue&type=template&id=7329089a&scoped=true"
import script from "./educateNormal.vue?vue&type=script&lang=js"
export * from "./educateNormal.vue?vue&type=script&lang=js"
import style0 from "./educateNormal.vue?vue&type=style&index=0&id=7329089a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7329089a",
  null
  
)

export default component.exports